// import { useEffect, useState } from "react";

const Hero = () => {
  // const [navOpen, setNavOpen] = useState(false);
  // const toggleNav = () => {
  //   setNavOpen(!navOpen);
  // };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const square = document.querySelector(".square.blue");
  //     if (square) {
  //       // Optional scroll handling logic
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <>
      <div className=" flex flex-col items-center justify-center w-screen h-screen min-h-[700px]">
        <nav className="absolute top-0 w-full h-[100px] bg-white animate-fadeInNav">
          <div className="w-[85%] mx-auto h-full flex justify-between items-center">
            <a
              href="/"
              id="logo"
              className="text-xl sm:text-[30px] font-semibold font-pacifico text-gray-800"
            >
              ABS Infotech
            </a>
            <a
              href="tel:+916289491639"
              className="text-xl font-semibold sm:text-[30px] underline"
            >
              +91 6289491639
            </a>
          </div>
        </nav>

        <div className="flex items-center justify-center w-full h-full px-6 md:px-12 bg-gray-50">
          <div className="relative text-center px-4 py-20 md:py-28">
            <h6 className="text-gray-400 text-xl md:text-2xl font-semibold uppercase animate-fadeIn">
              We Do
            </h6>
            <h1 className="text-gray-800 text-3xl md:text-6xl lg:text-7xl font-bold animate-fadeInTitle">
              Sell, Purchase & Repair <br /> Old Laptops and Desktops
            </h1>

            <div className="circle blue absolute top-[21px] left-0 w-[50px] h-[50px] md:w-[100px] md:h-[100px] rounded-full bg-gradient-to-r from-[#4F3DD5] to-[#3DB2D5] shadow-blueCircle animate-circleBlueMove"></div>

            <div className="square red absolute top-[15px] right-[15px] w-[50px] h-[50px] md:w-[100px] md:h-[100px] bg-gradient-to-br from-[#D53D3D] to-[#D53DC9] shadow-redSquare rotate-45 animate-squareRedMove"></div>

            <div className="triangle green absolute bottom-[-10px] left-[-10px] md:bottom-[-17px] md:left-[-20px] animate-triangleGreenMove">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 177.893 177.893"
                className="w-[75px] h-[75px] md:w-[175px] md:h-[175px]"
              >
                <defs>
                  <linearGradient
                    id="a"
                    x1="0.5"
                    x2="0.5"
                    y2="1"
                    gradientUnits="objectBoundingBox"
                  >
                    <stop offset="0" stopColor="#3dbed5" />
                    <stop offset="1" stopColor="#3dd55a" />
                  </linearGradient>
                  <filter
                    id="b"
                    x="0"
                    y="0"
                    width="177.893"
                    height="177.893"
                    filterUnits="userSpaceOnUse"
                  >
                    <feOffset dx="3" dy="3" />
                    <feGaussianBlur stdDeviation="7.5" result="c" />
                    <feFlood floodColor="#3dd55a" floodOpacity="0.396" />
                    <feComposite operator="in" in2="c" />
                    <feComposite in="SourceGraphic" />
                  </filter>
                </defs>
                <g className="filter drop-shadow-[3px_3px_15px_rgba(0,0,0,0.4)]">
                  <path
                    fill="url(#a)"
                    d="M136.727,21104.928l-50.222,100h100Z"
                    transform="translate(-8978.23 -19029.24) rotate(-25)"
                  />
                </g>
              </svg>
            </div>

            <div className="circle orange absolute bottom-0 right-0 w-[50px] h-[50px] md:w-[100px] md:h-[100px] rounded-full bg-gradient-to-r from-[#D53D3D] to-[#D5B83D] shadow-orangeCircle animate-circleOrangeMove"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;
